import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import Snowflake from './snowflake';
import Candy from './candy';
import Milk from './milk';
import Leaves from './leaves';
import Sock from './sock';
import Confetti from './confetti';
import gravity from './gravity';
import loop from './loop';
import track from './track';
import './game.css';
const goodies = [
    Candy,
    Sock,
    Milk,
    Leaves
];
// This is the fixed size of our world
// so that every game is simulated in identical conditions
// regardless of the screen size. We will then scale everything
// up or down in the render function depending on the screen res.
const BASE = {
    width: 1280,
    height: 680
};
class Game extends Component {
    initialState() {
        return {
            t: 0,
            paused: false,
            over: false,
            name: parse(window.localStorage.getItem('player'), {
                name: null
            }).name,
            jumps: 20,
            score: 0,
            streak: [
                0
            ],
            dimensions: BASE,
            screen: computeScreenDimensions(),
            highscores: parse(window.localStorage.getItem('highscores'), []),
            scoreRecorded: false,
            ball: {
                visible: true,
                position: {
                    x: BASE.width / 2,
                    y: 0
                },
                velocity: {
                    x: 0,
                    y: 0
                },
                mass: 2,
                radius: 64,
                restitution: -0.8
            },
            candy: {
                visible: true,
                type: random(0, 3),
                position: randomPos(BASE),
                radius: 100
            },
            confetti: {
                visible: false,
                position: {
                    x: 0,
                    y: 0
                }
            }
        };
    }
    componentDidMount() {
        this.loop = loop({
            getState: ()=>this.state,
            update: (state, t, step, alpha)=>this.update(state, t, step, alpha),
            render: (state, alpha)=>{
                this.setState(state);
            }
        });
        document.addEventListener('keydown', key('SPACE', ()=>this.jump()));
        document.addEventListener('keydown', key('P', ()=>this.pause()));
        document.addEventListener('touchstart', ()=>this.jump(), false);
        document.addEventListener('click', ()=>this.jump(), false);
        window.addEventListener('resize', ()=>{
            this.setState({
                screen: computeScreenDimensions()
            });
        });
    }
    pause() {
        this.loop.pause();
        this.setState({
            paused: !this.state.paused
        });
    }
    update(state, t, dt) {
        let { ball, candy, confetti, score, jumps, streak, dimensions } = state;
        let nextBall = gravity(dt, ball, dimensions);
        if (overlap(nextBall, candy)) {
            confetti = this.revealConfetti(candy.position);
            candy = this.moveCandy(dimensions);
            streak[streak.length - 1] += 1;
            score = score + sum(streak);
            jumps = jumps + 2 + sum(streak);
            // TODO - find a more elegant solution
            clearTimeout(this.gameOverTimeout);
        }
        return {
            ball: nextBall,
            candy,
            confetti,
            score,
            jumps,
            streak,
            dimensions,
            t
        };
    }
    jump() {
        let { paused, ball, over, jumps, streak } = this.state;
        if (paused) return;
        // game is in over state, restart the game upon hitting space
        if (over) {
            this.setState(this.initialState());
            return;
        }
        // if no jumps are left, stop doing stuff
        if (jumps <= 0) {
            return;
        }
        ball.velocity.y = -17;
        ball.velocity.x = (Math.random() > 0.5 ? 1 : -1) * Math.random() * 20;
        if (streak[streak.length - 1] === 0) {
            streak = [
                0
            ];
        } else {
            streak.push(0);
        }
        if (jumps === 1) {
            // TODO clear if score goes up
            this.gameOverTimeout = setTimeout(()=>{
                let { jumps } = this.state;
                if (jumps > 0) {
                    return;
                }
                this.gameOver();
            }, 3000);
        }
        track.jump();
        this.setState({
            ball: ball,
            jumps: this.state.jumps - 1,
            streak: streak
        });
    }
    gameOver() {
        let { name, score, highscores, scoreRecorded } = this.state;
        if (score > 0) {
            track.score(name, score);
        }
        if (name && score > 0 && !scoreRecorded) {
            highscores.push({
                name,
                score
            });
            highscores.sort((a, b)=>b.score - a.score);
            highscores = highscores.slice(0, 10);
            window.localStorage.setItem('highscores', JSON.stringify(highscores));
        }
        this.setState({
            over: true,
            highscores,
            scoreRecorded: true
        });
    }
    // TODO, find a more elegant way
    revealConfetti(pos) {
        setTimeout(()=>{
            let confetti = this.state.confetti;
            confetti.visible = false;
            this.setState({
                confetti
            });
        }, 2000);
        return {
            visible: true,
            position: {
                x: pos.x,
                y: pos.y
            }
        };
    }
    moveCandy(dimensions) {
        return {
            type: random(0, 3),
            position: randomPos(dimensions),
            radius: 100,
            visible: true
        };
    }
    render() {
        let { streak, ball, candy, over, score, jumps, confetti, name } = this.state;
        let streakTotal = sum(streak);
        let { screen, dimensions } = this.state;
        let icePadding = 10 * 2;
        let scaleFactor;
        if ((screen.width - icePadding) / (screen.height - icePadding) > dimensions.width / dimensions.height) {
            scaleFactor = (screen.height - icePadding) / dimensions.height;
        } else {
            scaleFactor = (screen.width - icePadding) / dimensions.width;
        }
        let scale = (v)=>v * scaleFactor;
        let stageStyle = {
            position: 'absolute',
            top: 10,
            left: 0,
            right: 0,
            bottom: 0,
            marginLeft: 'auto',
            marginRight: 'auto',
            // marginTop: 'auto',
            // marginBottom: 'auto',
            width: scale(dimensions.width),
            height: scale(dimensions.height),
            boxSizing: 'border-box'
        };
        let confettiStyle = {
            opacity: !over && confetti.visible ? 1 : 0,
            top: scale(confetti.position.y) - 10,
            left: scale(confetti.position.x) - 20,
            transformOrigin: 'left top',
            transform: `scale(${scaleFactor})`
        };
        let snowflakeStyle = {
            left: scale(ball.position.x),
            top: scale(ball.position.y),
            transformOrigin: 'left top',
            transform: `scale(${scaleFactor})`
        };
        let candyStyle = {
            opacity: !over && candy.visible ? 1 : 0,
            left: scale(candy.position.x),
            top: scale(candy.position.y),
            transformOrigin: 'left top',
            transform: `scale(${scaleFactor})`
        };
        let Goody = goodies[candy.type];
        return /*#__PURE__*/ _jsxs("div", {
            className: "Game",
            style: stageStyle,
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "Score",
                    children: [
                        "Score: ",
                        /*#__PURE__*/ _jsx("span", {
                            className: "b",
                            children: score
                        }),
                        /*#__PURE__*/ _jsx("span", {
                            children: " | "
                        }),
                        "Jumps: ",
                        /*#__PURE__*/ _jsx("span", {
                            className: "b",
                            children: jumps
                        })
                    ]
                }),
                over ? this.renderGameOver() : null,
                /*#__PURE__*/ _jsx("div", {
                    className: "Name",
                    children: /*#__PURE__*/ _jsx("input", {
                        className: "Name-input",
                        type: "text",
                        placeholder: "Highscore name",
                        value: name || '',
                        onInput: (e)=>this.setName(e.target.value)
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "ConfettiContainer",
                    style: confettiStyle,
                    children: /*#__PURE__*/ _jsx(Confetti, {
                        label: streakTotal > 1 ? '+' + streakTotal : ''
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "SnowflakeContainer",
                    style: snowflakeStyle,
                    children: /*#__PURE__*/ _jsx(Snowflake, {})
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "CandyContainer",
                    style: candyStyle,
                    children: /*#__PURE__*/ _jsx(Goody, {})
                })
            ]
        });
    }
    renderGameOver() {
        let { highscores } = this.state;
        return /*#__PURE__*/ _jsx("div", {
            className: "GameOver",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "GameOver-inner",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "GameOver-label",
                        children: "GAME OVER"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "Highscore",
                        children: highscores.map((h, i)=>{
                            return /*#__PURE__*/ _jsxs("div", {
                                children: [
                                    h.name,
                                    " - ",
                                    h.score
                                ]
                            }, i);
                        })
                    })
                ]
            })
        });
    }
    setName(name) {
        this.setState({
            name
        });
        window.localStorage.setItem('player', JSON.stringify({
            name
        }));
    }
    constructor(){
        super();
        this.state = this.initialState();
    }
}
export { Game as default };
function overlap(b1, b2) {
    if (!b1.visible || !b2.visible) return false;
    let s = (box)=>({
            left: box.position.x + box.radius / 5,
            right: box.position.x + box.radius - box.radius / 5,
            top: box.position.y + box.radius / 5,
            bottom: box.position.y + box.radius - box.radius / 5
        });
    let box1 = s(b1);
    let box2 = s(b2);
    return !(box1.right < box2.left || box1.left > box2.right || box1.top > box2.bottom || box1.bottom < box2.top);
}
function computeScreenDimensions() {
    return {
        width: window.innerWidth,
        height: window.innerHeight
    };
}
function key(keyName, fn) {
    let keys = {
        'SPACE': 32,
        'P': 80
    };
    return function onSpaceKey(event) {
        if (event.keyCode === keys[keyName]) {
            fn(event);
        }
    };
}
function parse(str, fallback) {
    try {
        return JSON.parse(str) || fallback;
    } catch (err) {
        return fallback;
    }
}
function random(min, max) {
    return min + Math.floor(Math.random() * (max - min + 1));
}
function randomPos(dim) {
    return {
        x: random(0, dim.width - 100),
        y: Math.max(0, random(0, dim.height - 100 - 1 / 5 * dim.height))
    };
}
function sum(list) {
    return list.reduce((total, v)=>total + v, 0);
}
